// Add your JS customizations here
jQuery(document).ready(function($) {
	if (jQuery.cookie('bspoke_privacy_notice') == 'true') {
 		$('#privacy_notice').addClass('no_show');
	};


	$('body').addClass('active');
	new WOW().init();
	$(window).on('scroll', function() {
		if ($(window).scrollTop() > 50) {
			$('#bspoke_nav').addClass('scrolled');
			$('#book_float').removeClass('text-white');
			$('#book_float').addClass('text-primary');
		} else {
			$('#bspoke_nav').removeClass('scrolled');
			$('#book_float').removeClass('text-primary');
			$('#book_float').addClass('text-white');
		}
	});

	$(window).on('load', function() {
		if ($(window).scrollTop() > 50) {
			$('#bspoke_nav').addClass('scrolled');
			$('#book_float').removeClass('text-white');
			$('#book_float').addClass('text-primary');
		} else {
			$('#bspoke_nav').removeClass('scrolled');
			$('#book_float').removeClass('text-primary');
			$('#book_float').addClass('text-white');
		}
	});

	$('.search_icon').click(function(event) {
		event.preventDefault();
		$('#bspoke_nav').toggleClass('search_open');
		$('#search').toggleClass('active');
		$('#book_float').toggleClass('search_open');
		$('body').toggleClass('modal_open');
	});

	$('.close_search').click(function(event) {
		event.preventDefault();
		$('#bspoke_nav').removeClass('search_open');
		$('#search').removeClass('active');
		$('#book_float').removeClass('search_open');
		$('body').removeClass('modal_open');
	});

	$('#book_float').click(function(event) {
		event.preventDefault();
		$(this).addClass('inactive');
		$('#book_consultation').addClass('active');
		$('body').addClass('modal_open');
	});

	$('#book_float_xs a').click(function(event) {
		event.preventDefault();
		$('#book_float_xs').toggleClass('active');
		$('#book_consultation').toggleClass('active');
		$('body').toggleClass('modal_open');
	});

	$('.book_trigger').click(function(event) {
		event.preventDefault();
		$('#book_float_xs').toggleClass('active');
		$('#book_consultation').toggleClass('active');
		$('body').toggleClass('modal_open');
	});

	$('#close_book').click(function(event) {
		event.preventDefault();
		$('#book_float').removeClass('inactive');
		$('#book_consultation').removeClass('active');
		$('body').removeClass('modal_open');
		$('#book_float_xs').removeClass('active');
	});

	$('#privacy_notice .accept').click(function(event) {
		event.preventDefault();
		$('#privacy_notice').addClass('hide');
		$.cookie('bspoke_privacy_notice', 'true', { expires: 7, path: '/', secure: true });
	});

	$('#input_2_5').select2({
		placeholder: 'Choice of Procedure',
		width: '100%',
		minimumResultsForSearch: Infinity,
	});

	$('.menu_icon').click(function(event) {
		event.preventDefault();
		$('#bspoke_nav').toggleClass('menu_open');
		$('#bspoke_menu').toggleClass('active');
		$('#book_float').toggleClass('search_open');
		$('body').toggleClass('modal_open');
		$('#bspoke_menu_top .has_sub a').removeClass('active');
		$('.second_level').removeClass('active');
		$('.second_level .has_sub a').removeClass('active');
		$('.second_level .dropdown-toggle').removeClass('active').removeClass('show').attr('aria-expanded',false);
		$('.second_level .dropdown-menu').removeClass('show');
		$('.third_level').removeClass('active');
		$('.top_level_container').removeClass('hide_xs');
	});

	$('#bspoke_menu_top .has_sub a').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		if($(this).hasClass('active')) {
			$('.second_level .has_sub a').removeClass('active');
			$('.second_level').removeClass('active');
			$('.third_level').removeClass('active');
			$('.top_level_container').removeClass('hide_xs');
			$(this).removeClass('active');
		} else {
			$('#bspoke_menu_top .has_sub a').not(this).removeClass('active');
			$('.second_level .has_sub a').removeClass('active');
			$('.second_level').removeClass('active');
			$('.third_level').removeClass('active');
			$(target).toggleClass('active');
			$(this).toggleClass('active');
			$('.top_level_container').addClass('hide_xs');
		}
	});

	$('.close_sub').click(function(event) {
		event.preventDefault();
		$('#bspoke_menu_top .has_sub a').removeClass('active');
		$('.second_level').removeClass('active');
		$('.second_level .dropdown-toggle').removeClass('active');
		$('.top_level_container').removeClass('hide_xs');
	});

	$('.second_level .has_sub a').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		if($(this).hasClass('active')) {
			$('.third_level').removeClass('active');
			$(this).removeClass('active');
		} else {
			$('.second_level .has_sub a').not(this).removeClass('active');
			$('.second_level .has_sub a').removeClass('active');
			$('.third_level').removeClass('active');
			$(target).toggleClass('active');
			$(this).toggleClass('active');
		}
	});

	$('.second_level .dropdown-toggle').click(function(event) {
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
		} else {
			$(this).addClass('active');
		}
	});


	if ($('.page-template-home').length > 0) {

		$('#header_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 1000,
			fade: true,
			prevArrow: $('#header_carousel_controls_prev'),
			nextArrow: $('#header_carousel_controls_next'),
		});

		$('#as_seen_in_carousel').slick({
			slidesToShow: 4,
			infinite: true,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			autoplay: true,
			speed: 1000,
			autoplaySpeed: 1000,
			prevArrow: $('#as_seen_in_carousel_controls_prev'),
			nextArrow: $('#as_seen_in_carousel_controls_next'),
			responsive: [
			    {
			      	breakpoint: 769,
			      	settings: {
			      		slidesToShow: 2,
			      	}	
			    },
			    {
			      	breakpoint: 400,
			      	settings: {
			      		slidesToShow: 2,
			      	}	
			    },
			]
		});

		$('#procedures_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 3000,
			speed: 500,
			fade: true,
			prevArrow: $('#procedures_carousel_controls_prev'),
			nextArrow: $('#procedures_carousel_controls_next'),
		});

		$('#conditions_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
  			centerPadding: '3rem',
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 500,
			fade: false,
			prevArrow: $('#conditions_carousel_controls_prev'),
			nextArrow: $('#conditions_carousel_controls_next'),
		});

		$('#conditions_desktop .cat_link').click(function(event) {
			event.preventDefault();
			var target = $(this).data('menu');
			$('#bspoke_nav').toggleClass('menu_open');
			$('#bspoke_menu').toggleClass('active');
			$('#book_float').toggleClass('search_open');
			$('body').toggleClass('modal_open');
			$('#menu-item-349 a').addClass('active');
			$('#conditions_menu').addClass('active');
			$('.second_level .has_sub a[href="'+target+'"]').addClass('active');
			$(target).addClass('active');
			$('.top_level_container').removeClass('hide_xs');
		});

		$('#conditions_carousel .cat_link').click(function(event) {
			event.preventDefault();
			var target = $(this).data('menu');
			$('#bspoke_nav').toggleClass('menu_open');
			$('#bspoke_menu').toggleClass('active');
			$('#book_float').toggleClass('search_open');
			$('body').toggleClass('modal_open');
			$('.top_level_container').addClass('hide_xs');
			$('#menu-item-349 a').addClass('active');
			$('#conditions_menu').addClass('active');
			$('#conditions_mobile_list li'+target+' .dropdown-toggle').addClass('show').addClass('active').attr('aria-expanded',true);
			$('#conditions_mobile_list li'+target+' .dropdown-menu').addClass('show');
			
		});
	};

	$('#news_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: false,
		speed: 500,
		fade: true,
		prevArrow: $('#news_carousel_controls_prev'),
		nextArrow: $('#news_carousel_controls_next'),
	});

	$('#main_content_readmore').click(function(event) {
		$('#main_content .text_content').toggleClass('more');
		$(this).text($(this).text() == 'Read more' ? 'Read less' : 'Read more');
	});

	if ($('.page-template-dr_faisal').length > 0) {
		$('#qualifications_carousel').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 500,
			fade: false,
			prevArrow: $('.qual_prev'),
			nextArrow: $('.qual_next'),
		});
	};

	if ($('.page-template-facilities').length > 0) {
		$('.jump_to').click(function() {
			var target = $(this).attr('href');
			$('html, body').animate({
                scrollTop: $(target).offset().top
            }, 500);
			var label = $('#facility_header_1 .label');
			$(label).text($(label).text() == 'Open' ? 'Close' : 'Open');
		});
		$('.accordion-header a').click(function() {
			var label = $(this).find('.label');
			$(label).text($(label).text() == 'Open' ? 'Close' : 'Open');
		});
	};

	if ($('.single-treatment').length > 0) {

		$('#as_seen_in_carousel').slick({
			slidesToShow: 3,
			infinite: true,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 1000,
			autoplaySpeed: 1000,
			prevArrow: $('#as_seen_in_carousel_controls_prev'),
			nextArrow: $('#as_seen_in_carousel_controls_next'),
			responsive: [
			    {
			      	breakpoint: 769,
			      	settings: {
			      		slidesToShow: 2,
			      	}	
			    },
			    {
			      	breakpoint: 400,
			      	settings: {
			      		slidesToShow: 2,
			      	}	
			    },
			]
		});
		
		$('#related_procedures_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 500,
			fade: true,
			prevArrow: $('#related_procedures_carousel_controls_prev'),
			nextArrow: $('#related_procedures_carousel_controls_next'),
		});

		$('#videos_procedure_carousel').on('init', function(event, slick){
			if ($(window).width() > 992) {
				var tab_height = $('#video_tabs').outerHeight(true);
				var slickHeight = $('#video_tabs_content').outerHeight(true);
				var combined = tab_height + slickHeight;
				console.log(combined);
				$('#videos_bg .card').css('height',combined);
			} else {
				var tab_height = $('#video_tabs').outerHeight(true);
				var tab_height_half = tab_height / 2;
				var slickHeight = $('#video_tabs_content').outerHeight(true);
				var combined = tab_height_half + slickHeight;
				console.log(combined);
				$('#videos_bg .card').css('height',combined).css('margin-top',tab_height_half);
			}
		});

		$('#videos_patient_carousel').on('init', function(event, slick){
			if ($(window).width() > 992) {
				var tab_height = $('#video_tabs').outerHeight(true);
				var slickHeight = $('#video_tabs_content').outerHeight(true);
				var combined = tab_height + slickHeight;
				$('#videos_bg .card').css('height',combined);
			} else {
				var tab_height = $('#video_tabs').outerHeight(true);
				var tab_height_half = tab_height / 2;
				var slickHeight = $('#video_tabs_content').outerHeight(true);
				var combined = tab_height_half + slickHeight;
				console.log(combined);
				$('#videos_bg .card').css('height',combined).css('margin-top',tab_height_half);
			}

		});

		$('#videos_procedure_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 500,
			fade: true,
			prevArrow: $('.videos_procedure_prev'),
			nextArrow: $('.videos_procedure_next'),
		});

		$('#videos_patient_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 500,
			fade: true,
			prevArrow: $('.videos_patient_prev'),
			nextArrow: $('.videos_patient_next'),
		});

		$('#video_tabs_procedure').click(function() {
			$('#videos_procedure_carousel').slick('refresh');
		});

		$('#video_tabs_patient').click(function() {
			$('#videos_patient_carousel').slick('refresh');
		});

		$('#before_afters_carousel').on('init', function(event, slick){
			if ($(window).width() > 992) {
				var imagesHeight = $('#before_afters_carousel .ba_images').outerHeight(true);
				$('#before_afters_bg .card').css('height',imagesHeight);
			} else {
				var imagesHeight = $('#before_afters_carousel .ba_images').outerHeight(true);
				var descHeight = $('#before_afters_carousel .ba_description').outerHeight(true);
				var ba_combined = imagesHeight + descHeight - 50;
				$('#before_afters_bg .card').css('height',ba_combined);
			}
		});

		$('#before_afters_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 500,
			fade: true,
			prevArrow: $('.before_afters_prev'),
			nextArrow: $('.before_afters_next'),
		});

		$('#downloads_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			speed: 500,
			fade: true,
			prevArrow: $('.downloads_prev'),
			nextArrow: $('.downloads_next'),
		});

	};

	$('.launch_video').click(function() {
		var src = $(this).data('src');
		var type = $(this).data('type');
		$('#video_player iframe').attr('src',src);
		$('#video_player iframe').addClass(type);
	});

	$('#video_player').on('hidden.bs.modal', function (e) {
		$('#video_player .ratio iframe').attr('src','');
		$('#video_player .ratio iframe').removeClass('.vimeo').removeClass('youtube');
	});

	const para1 = document.getElementsByClassName('para1');

	new simpleParallax(para1, {
		//delay: .25,
		orientation: 'up',
		scale: 1.5,
		overflow: false,
		//transition: 'cubic-bezier(0,0,0,1)',
	});

	$('.widget_categories select').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Category',
	});

	$('.widget_archive select').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Archive',
	});
});
